<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="CustCreditTableRef" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke">
        <template #query>
          {{ $t("common.customer") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
            v-model="AccountNum"></el-input>
        </template>
        <template #toolbar>
          <el-checkbox :label="$t('common.show_all')" v-model="isAll" class="ml-2" @change="showAll"></el-checkbox>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import * as CustomerCreditSearchController from "../../controllers/fi/CustomerCreditSearchController"

export default {
  name: "ExchRate",
  components: {
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_customer_credit",
      },
      fields: CustomerCreditSearchController.fields,
      dataForm: _.cloneDeep(CustomerCreditSearchController.dataForm),
      rules: CustomerCreditSearchController.rules,
      AccountNum: "",
      isBusy: false,
      isAll: false,
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data) {
      this.isBusy = true
      let _params = { id: { ">": 0 } }
      if (this.AccountNum != "") {
        _params.AccountNum = { like: "%" + this.AccountNum + "%" }
      }

      set_data([])
      let _result = await CustomerCreditSearchController.methods.getData(
        _params
      )

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.his_credit_list = _result[0]
        let _list = _.filter(_result[0], function (t) {
          if (
            t.dispUsedCreditAmount != 0 ||
            t.dispopenInvoiceBalanceMSTDue0 != 0 ||
            t.dispopenInvoiceBalanceMSTDue30 != 0 ||
            t.dispopenInvoiceBalanceMSTDue31_60 != 0 ||
            t.dispopenInvoiceBalanceMSTDue60Above != 0 ||
            t.dispopenInvoiceBalanceMSTDueAbove_N != 0 ||
            t.dispopenInvoiceBalanceMSTDue_N != 0
          ) {
            return t
          }
        })
        set_data(_list)
      }
      this.isBusy = false
    },
    showAll() {
      if (this.isAll) {
        this.$refs.CustCreditTableRef.SetData(this.his_credit_list)
      } else {
        let _list = _.filter(this.his_credit_list, function (t) {
          if (
            t.dispUsedCreditAmount != 0 ||
            t.dispopenInvoiceBalanceMSTDue0 != 0 ||
            t.dispopenInvoiceBalanceMSTDue30 != 0 ||
            t.dispopenInvoiceBalanceMSTDue31_60 != 0 ||
            t.dispopenInvoiceBalanceMSTDue60Above != 0 ||
            t.dispopenInvoiceBalanceMSTDueAbove_N != 0 ||
            t.dispopenInvoiceBalanceMSTDue_N != 0
          ) {
            return t
          }
        })
        this.$refs.CustCreditTableRef.SetData(_list)
      }
    },
    //#endregion

    //#region 保存
    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion
  },
}
</script>
